import App from '@/app';
import '@/global.less';
import '@/global.tsx';
import '@/global_components.less';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';

// eslint-disable-next-line react/no-deprecated, @typescript-eslint/no-deprecated
ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root'),
);
